var React = require('react');

function Ball9 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M89.1,45c0-7.1-4.9-13-11.4-14.6c6.6-1.6,11.4-7.5,11.4-14.5c0-8.3-6.7-15-15-15c-7.1,0-13,4.9-14.6,11.4\n\tC58,5.8,52.1,0.9,45,0.9c-7.1,0-13,4.9-14.6,11.4C28.8,5.8,22.9,0.9,15.9,0.9c-8.3,0-15,6.7-15,15c0,7.1,4.9,13,11.4,14.5\n\tC5.8,32,0.9,37.9,0.9,45c0,7.1,4.9,13,11.4,14.6C5.8,61.2,0.9,67.1,0.9,74.1c0,8.3,6.7,15,15,15c7.1,0,13-4.9,14.5-11.4\n\tC32,84.2,37.9,89.1,45,89.1c7.1,0,13-4.9,14.6-11.4c1.6,6.6,7.5,11.4,14.6,11.4c8.3,0,15-6.7,15-15c0-7.1-4.9-13-11.4-14.5\n\tC84.2,58,89.1,52.1,89.1,45L89.1,45z M89.1,45"}));
}

Ball9.defaultProps = {"viewBox":"0 0 90 90"};

module.exports = Ball9;

Ball9.default = Ball9;
